var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19814_8343",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19814_8343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 12.9788C9.88905 12.9788 9.78488 12.9613 9.68766 12.9263C9.59044 12.8919 9.50016 12.833 9.41683 12.7497L6.41683 9.74967C6.26405 9.5969 6.18766 9.40245 6.18766 9.16634C6.18766 8.93023 6.26405 8.73579 6.41683 8.58301C6.56961 8.43023 6.76738 8.35023 7.01016 8.34301C7.2535 8.33634 7.45155 8.4094 7.60433 8.56217L9.16683 10.1247V4.16634C9.16683 3.93023 9.24683 3.73217 9.40683 3.57217C9.56627 3.41273 9.76405 3.33301 10.0002 3.33301C10.2363 3.33301 10.4343 3.41273 10.5943 3.57217C10.7538 3.73217 10.8335 3.93023 10.8335 4.16634V10.1247L12.396 8.56217C12.5488 8.4094 12.7468 8.33634 12.9902 8.34301C13.2329 8.35023 13.4307 8.43023 13.5835 8.58301C13.7363 8.73579 13.8127 8.93023 13.8127 9.16634C13.8127 9.40245 13.7363 9.5969 13.5835 9.74967L10.5835 12.7497C10.5002 12.833 10.4099 12.8919 10.3127 12.9263C10.2154 12.9613 10.1113 12.9788 10.0002 12.9788ZM5.00016 16.6663C4.54183 16.6663 4.14961 16.5033 3.8235 16.1772C3.49683 15.8505 3.3335 15.458 3.3335 14.9997V13.333C3.3335 13.0969 3.41322 12.8988 3.57266 12.7388C3.73266 12.5794 3.93072 12.4997 4.16683 12.4997C4.40294 12.4997 4.601 12.5794 4.761 12.7388C4.92044 12.8988 5.00016 13.0969 5.00016 13.333V14.9997H15.0002V13.333C15.0002 13.0969 15.0802 12.8988 15.2402 12.7388C15.3996 12.5794 15.5974 12.4997 15.8335 12.4997C16.0696 12.4997 16.2674 12.5794 16.4268 12.7388C16.5868 12.8988 16.6668 13.0969 16.6668 13.333V14.9997C16.6668 15.458 16.5038 15.8505 16.1777 16.1772C15.851 16.5033 15.4585 16.6663 15.0002 16.6663H5.00016Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b1c5a313f03b0a1a1b96fdd6607a8d47.svg";
export { ForwardRef as ReactComponent };